/**
 * Validates a date of birth string in MM/DD/YYYY format.
 */

const MONTHS_IN_ONE_YEAR = 12;

const MAX_DAY_IN_MONTH = 31;

export const validateDateOfBirth = (dob: string): string | null => {
  if (!dob) return 'Date of birth is required';

  const match = dob.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return 'Please enter a complete date (mm/dd/yyyy)';

  const month = parseInt(match[1], 10);
  const day = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);

  if (month < 1 || month > MONTHS_IN_ONE_YEAR) {
    return 'Please enter a valid month';
  }

  if (day < 1 || day > MAX_DAY_IN_MONTH) return 'Please enter a valid day';

  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return 'Please enter a valid date';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (date > today) return 'Date of birth cannot be in the future';

  const minDate = new Date(today.getFullYear() - 120, 0, 1);
  if (date < minDate) return 'Please enter a valid date of birth';

  return null;
};

export const isValidDateOfBirth = (dob: string): boolean =>
  validateDateOfBirth(dob) === null;
